export default "__VITE_ASSET__bd252619__"